import React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardFooter,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Smartphone, ExternalLink } from "lucide-react";
import { getAppStoreUrl } from "@/utils/deviceDetection";
import { useApplication } from "@/contexts/ApplicationContext";

const TrialConfirmation = () => {
  const appStoreUrl = getAppStoreUrl();
  const { application } = useApplication();

  const getAirtablePersonId = () => {
    if (application.airtablePersonId) {
      console.log("Airtable Person ID:", application);
      const airtablePersonId = application.airtablePersonId.split("-")[0];
      return airtablePersonId;
    }
    return "";
  };

  return (
    <div className="max-w-md mx-auto">
      <Card>
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="rounded-full bg-green-100 p-3">
              <Smartphone className="h-8 w-8 text-green-600" />
            </div>
          </div>
          <CardTitle className="text-xl font-bold text-jungle mb-2">
            Congratulations!
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="bg-gray-50 p-4 rounded-lg">
            <p className="text-sm text-gray-600">
              Congratulations you have been invited to pick up trial blocks with
              HIVED. Go to the HIVED team app to pick up your trial block.
            </p>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg">
            <p className="text-md text-gray-600">
              Your HIVED Person ID:{" "}
              <span className="font-bold">{getAirtablePersonId()}</span>
            </p>
          </div>
        </CardContent>
        <CardFooter className="flex flex-col space-y-3">
          {/* <a
            href="https://hived.space/team-app"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full"
          >
            <Button className="w-full bg-honeycomb hover:bg-amber-500 text-white">
              Go to HIVED Team App <ExternalLink className="ml-2 h-4 w-4" />
            </Button>
          </a> */}
          <a
            href={appStoreUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full"
          >
            <Button variant="outline" className="w-full bg-honeycomb hover:bg-amber-500 text-white">
              Download HIVED Team App <ExternalLink className="ml-2 h-4 w-4" />
            </Button>
          </a>
        </CardFooter>
      </Card>
    </div>
  );
};

export default TrialConfirmation;
